var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c939058435bf7a40a5c9b7f50ed81d208a0b6e1e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["jamstack-ebook-website@mcavaliere"]={id:"c939058435bf7a40a5c9b7f50ed81d208a0b6e1e"};
      